<div class="renew-slip-container">
  <div class="container py-5">
    <!-- Header -->
    <div class="header-section mb-4">
      <h1 class="page-title">
        <i class="bi bi-receipt"></i>
        ใบเสร็จรับเงิน/ใบกำกับภาษี
      </h1>
      <p class="page-subtitle">Receipt/Tax Invoice Generator</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !slipData" class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ error }}
    </div>

    <!-- Error State: มีปุ่มกลับให้ผู้ใช้ออกจากหน้านี้ได้ -->
    <div *ngIf="error && !slipData" class="mb-4">
      <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
        <i class="bi bi-arrow-left me-2"></i>กลับ
      </button>
    </div>

    <!-- Slip Preview -->
    <div *ngIf="slipData" class="slip-preview-section">
      <!-- ใบเสร็จตัวอย่าง: เตือนให้ชัดว่าไม่ใช่เอกสารจริง -->
      <div *ngIf="isSampleData" class="alert alert-warning d-flex align-items-start mb-3">
        <i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
        <div>
          <strong>ตัวอย่างใบเสร็จ — ไม่ใช่เอกสารจริง</strong>
          <div class="small">ข้อมูลในหน้านี้เป็นข้อมูลตัวอย่างสำหรับดูรูปแบบเท่านั้น ไม่สามารถใช้อ้างอิงทางบัญชีหรือภาษีได้</div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons mb-3">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
          <i class="bi bi-arrow-left me-2"></i>กลับ
        </button>
        <button type="button" class="btn btn-success" (click)="printPDF()" *ngIf="!isSampleData">
          <i class="bi bi-printer me-2"></i>พิมพ์
        </button>
      </div>

      <!-- Staff Receipt Management Panel -->
      <div *ngIf="userType === 'staff' && isReceiptManageable" class="staff-action-panel mb-4 p-4 rounded-3 border"
        [ngClass]="hasActiveReceipt ? 'border-success bg-success-subtle' : 'border-warning bg-warning-subtle'">
        <div class="d-flex align-items-start gap-3">
          <div class="staff-action-icon flex-shrink-0">
            <div class="icon-circle" [ngClass]="hasActiveReceipt ? 'icon-circle-success' : 'icon-circle-warning'">
              <i class="bi" [ngClass]="hasActiveReceipt ? 'bi-receipt-cutoff' : 'bi-exclamation-triangle'"></i>
            </div>
          </div>
          <div class="flex-grow-1">
            <div *ngIf="hasActiveReceipt">
              <h6 class="fw-bold text-success mb-1">ใบเสร็จนี้มีผล (สร้างใหม่)</h6>
              <p class="text-muted small mb-3">รหัสใบเสร็จ: <strong class="text-dark">{{ receiptLogData?.codeReceipt || rawApiData?.codeReceipt }}</strong> — หากต้องการยกเลิกใบเสร็จนี้ ระบบจะลบรหัสใบเสร็จออกและบันทึกสถานะเป็นยกเลิก</p>

              <!-- Trigger button -->
              <button *ngIf="!showCancelForm" type="button" class="btn btn-danger" (click)="openCancelForm()"
                [disabled]="isActionLoading">
                <i class="bi bi-x-circle me-2"></i>ยกเลิกใบเสร็จ
              </button>

              <!-- Cancel reason form -->
              <div *ngIf="showCancelForm" class="cancel-reason-form mt-2 p-3 rounded-3 bg-white border">
                <label class="form-label fw-semibold mb-1">
                  <i class="bi bi-pencil-square me-1 text-danger"></i>เหตุผลในการยกเลิกใบเสร็จ
                  <span class="text-danger">*</span>
                </label>
                <textarea class="form-control mb-3" rows="3" [(ngModel)]="cancelReasonInput"
                  placeholder="ระบุเหตุผล เช่น ออกใบเสร็จผิดประเภท, ข้อมูลผู้ชำระไม่ถูกต้อง ฯลฯ"
                  [disabled]="isActionLoading"></textarea>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-danger" (click)="cancelReceipt()" [disabled]="isActionLoading">
                    <span *ngIf="isActionLoading" class="spinner-border spinner-border-sm me-2"></span>
                    <i *ngIf="!isActionLoading" class="bi bi-check-circle me-2"></i>
                    ยืนยันการยกเลิก
                  </button>
                  <button type="button" class="btn btn-outline-secondary" (click)="closeCancelForm()"
                    [disabled]="isActionLoading">
                    ยกเลิก
                  </button>
                </div>
              </div>
            </div>
            <!-- ใบเสร็จถูกยกเลิกแล้ว -->
            <div *ngIf="isReceiptCancelled">
              <h6 class="fw-bold text-warning mb-1">ใบเสร็จนี้ถูกยกเลิกแล้ว</h6>
              <p *ngIf="receiptLogData?.cancelReason || rawApiData?.cancelReason" class="mb-2 small">
                <span class="badge bg-danger-subtle text-danger border border-danger-subtle me-1">เหตุผล</span>
                <span class="text-dark">{{ receiptLogData?.cancelReason || rawApiData?.cancelReason }}</span>
              </p>
              <p class="text-muted small mb-3">ต้องการออกใบเสร็จใหม่สำหรับรายการนี้? ระบบจะสร้างรหัสใบเสร็จใหม่ให้อัตโนมัติ</p>
              <button type="button" class="btn btn-primary" (click)="reissueReceipt()" [disabled]="isActionLoading">
                <span *ngIf="isActionLoading" class="spinner-border spinner-border-sm me-2"></span>
                <i *ngIf="!isActionLoading" class="bi bi-receipt me-2"></i>
                ออกใบเสร็จใหม่
              </button>
            </div>

            <!-- ยังไม่เคยออกใบเสร็จ (ไม่ใช่กรณีถูกยกเลิก) -->
            <div *ngIf="hasNoReceiptYet">
              <h6 class="fw-bold text-secondary mb-1">ยังไม่ได้ออกใบเสร็จสำหรับรายการนี้</h6>
              <p class="text-muted small mb-3">
                รายการนี้ยังไม่มีรหัสใบเสร็จในระบบ กรุณาบันทึกสถานะการชำระเงินเป็น "ชำระเงินเสร็จสิ้น"
                ที่หน้ารายละเอียดคำขอก่อน หรือกดออกใบเสร็จที่นี่เพื่อให้ระบบสร้างรหัสใบเสร็จให้อัตโนมัติ
              </p>
              <button type="button" class="btn btn-primary" (click)="reissueReceipt()" [disabled]="isActionLoading">
                <span *ngIf="isActionLoading" class="spinner-border spinner-border-sm me-2"></span>
                <i *ngIf="!isActionLoading" class="bi bi-receipt me-2"></i>
                ออกใบเสร็จ
              </button>
            </div>
            <!-- Feedback messages -->
            <div *ngIf="actionError" class="alert alert-danger d-flex align-items-center mt-3 mb-0 py-2 px-3">
              <i class="bi bi-exclamation-circle me-2"></i>{{ actionError }}
            </div>
            <div *ngIf="actionSuccess" class="alert alert-success d-flex align-items-center mt-3 mb-0 py-2 px-3">
              <i class="bi bi-check-circle me-2"></i>{{ actionSuccess }}
            </div>
          </div>
        </div>
      </div>

      <!-- Slip Preview Card -->
      <div class="card slip-card">
        <div class="card-body p-4">
          <!-- Header -->
          <div class="slip-header text-center mb-4">
            <h2 class="organization-name">สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</h2>
            <h3 class="organization-name-en">The Valuers Association of Thailand</h3>
            <p class="organization-info">
              สำนักงานใหญ่ : อาคารสำนักงานที่ดินกรุงเทพมหานคร สาขาบางกอกน้อย ชั้น 3<br>
              ซอยจรัญสนิทวงศ์ 59 ถนนจรัญสนิทวงศ์ แขวงบางบำหรุ เขตบางพลัด กรุงเทพมหานคร 10700 เลขประจำตัวผู้เสียภาษี
              0-9930-00174-97-6<br>
              โทรศัพท์ 0-2435-9047, 0-2886-6335 โทรสาร 0-2435-5712-3 มือถือ 089-200-8885 Website : www.vat.or.th E-mail
              : vat.2012.vat&#64;gmail.com
            </p>
          </div>

          <hr class="my-4">

          <!-- Title -->
          <div class="slip-title text-center mb-4">
            <h3 class="title-th">ใบเสร็จรับเงิน/ใบกำกับภาษี</h3>
            <h4 class="title-en">Original Receipt/Tax Invoice</h4>
          </div>

          <!-- Receipt Info -->
          <div class="receipt-info mb-4">
            <div class="row">
              <div class="col-md-6">
                <p><strong>วันที่:</strong> {{ slipData.date }}</p>
              </div>
              <div class="col-md-6 text-end">
                <p><strong>เลขที่:</strong> {{ slipData.receiptNumber }}</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <p><strong>ได้รับเงินจาก:</strong></p>
              </div>
              <div class="col-md-6">
                <p><strong>ประเภท:</strong> {{ slipData.paymentType }}</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p><strong>ชื่อ:</strong> {{ slipData.payer.name }}</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p><strong>ที่อยู่:</strong> {{ slipData.payer.address }}</p>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p><strong>เลขประจำตัวผู้เสียภาษี:</strong> {{ slipData.payer.taxId || '-' }}</p>
              </div>
            </div>
            <!-- ออกใบเสร็จในนามนิติบุคคล: ช่อง "ชื่อ" เป็นชื่อองค์กร จึงระบุชื่อสมาชิกที่ใช้บริการไว้ด้วย -->
            <div class="row mt-2" *ngIf="slipData.payer.serviceRecipient">
              <div class="col-12">
                <p><strong>ผู้รับบริการ:</strong> {{ slipData.payer.serviceRecipient }}</p>
              </div>
            </div>
          </div>

          <!-- Items Table -->
          <div class="items-table mb-4">
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th class="text-center" style="width: 10%;">ลำดับ</th>
                  <th style="width: 40%;">รายการ</th>
                  <th class="text-center" style="width: 15%;">จำนวน</th>
                  <th class="text-end" style="width: 17.5%;">ราคาต่อหน่วย (บาท)</th>
                  <th class="text-end" style="width: 17.5%;">จำนวนเงิน (บาท)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of slipData.items">
                  <td class="text-center">{{ item.no }}</td>
                  <td>{{ item.description }}</td>
                  <td class="text-center">{{ item.quantity }}</td>
                  <td class="text-end">{{ item.pricePerUnit | number:'1.2-2':'th-TH' }}</td>
                  <td class="text-end">{{ item.amount | number:'1.2-2':'th-TH' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Summary -->
          <div class="summary-section mb-4">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div class="summary-row">
                  <span>จำนวนเงินก่อนภาษีมูลค่าเพิ่ม:</span>
                  <span class="amount">{{ slipData.subtotal | number:'1.2-2':'th-TH' }}</span>
                </div>
                <div class="summary-row">
                  <span>ภาษีมูลค่าเพิ่ม:</span>
                  <span class="amount">{{ slipData.vat | number:'1.2-2':'th-TH' }}</span>
                </div>
                <div class="summary-row total">
                  <span><strong>เงินรวมภาษีมูลค่าเพิ่ม:</strong></span>
                  <span class="amount"><strong>{{ slipData.total | number:'1.2-2':'th-TH' }}</strong></span>
                </div>
              </div>
            </div>
          </div>

          <hr class="my-4">

          <!-- Signature Section -->
          <div class="signature-section">
            <div class="row">
              <div class="col-md-6 text-center">
                <p class="mb-3">ผู้จัดการสมาคม</p>
                <div class="signature-placeholder mb-2">
                  <img src="assets/images/sign-manager.png" alt="Manager Signature" class="signature-image">
                </div>
                <div class="signature-line mb-2"></div>
                <p>(นางจันทราทิพย์  พานาดา)</p>
              </div>
              <div class="col-md-6 text-center">
                <p class="mb-3">เจ้าหน้าที่การเงิน</p>
                <div class="signature-placeholder mb-2">
                  <img src="assets/images/sign-account.png" alt="Finance Signature" class="signature-image">
                </div>
                <div class="signature-line mb-2"></div>
                <p>(นางสาวอุมากร  เงาประทีป)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons (Bottom) -->
      <div class="action-buttons mt-4">
        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
          <i class="bi bi-arrow-left me-2"></i>กลับ
        </button>
        <button type="button" class="btn btn-success" (click)="printPDF()">
          <i class="bi bi-printer me-2"></i>พิมพ์
        </button>
      </div>
    </div>
  </div>
</div>